module.exports = __webpack_public_path__ + "img/29.8c5828d1.jpg";